import { useQuery } from '@apollo/client';
import { useParams } from 'react-router';
import { useLocalization } from '../../../hooks/useLocalization';
import { FETCH_HOME_PAGE_CONFIGURATION_NAME } from './homePageConfigurationBreadcrumb.query';

export const HomePageConfigurationBreadcrumb = () => {
  const { translateBackendString } = useLocalization();
  const { homePageConfigurationId } = useParams();
  const { data } = useQuery(FETCH_HOME_PAGE_CONFIGURATION_NAME, {
    variables: { homePageConfigurationId: homePageConfigurationId ?? '' },
    skip: !homePageConfigurationId,
  });

  return translateBackendString(
    data?.fetchHomePageConfiguration?.homePageConfiguration?.translatedName,
  );
};
